import React, { useState, useEffect, useContext } from 'react';
import SHARED from '../../constants';
import { AdminContext } from '../../context/AdminContext';
import FileUploader from '../FileUploader';
import Loader from '../Loader';
// import FileUploader from '../FileUploader';
// import SHARED from '../../../constants';

// import AppImage from '../AppImage';

// import Loader from '../Loader';

// import Modal from '../../templates/Modal';
// import Crop from './crop';
// import CropImage from './CropImage/cropImage';
import styles from './style.module.scss';
// import { AdminContext } from '../../../context/AdminContext';

export default function FileUpload({
  classNameForm = '',

  // accept = 'image/png, image/gif, image/jpeg, image/svg+xml, image/jpg ',
  accept = '',

  children,

  setSelectedFile,
  cropMode = false,
  title = '',
  titleStye,
  affix = '',
  affixstyle,
  removeImage,

  id,
  error,
  showError,
  loading,

  loadingStyle = styles.lds_ring,
  width = 'w-[20px]',
  height = 'h-[20px]',
  inputclassname = '',
  uploadContainerStyle,
  showToggle = false,
  suitableAspect = 16 / 9,
  cropContainer = '',
  extraLabelStyle = 'nothing',
  type = '',
}) {
  const { url } = SHARED;
  const [loadingU, setLoadingU] = useState(loading);
  const [showCrop, setShowCrop] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const { themeColor } = useContext(AdminContext);

  useEffect(() => {
    setLoadingU(loading);
  }, [loading]);
  const handleShowModal = () => {
    setShowCrop(false);
  };

  console.log('aspect2', suitableAspect);
  return (
    <>
      <form className={classNameForm}>
        <div
          className={`flex flex-row justify-start align-center ${uploadContainerStyle} cursor-pointer`}
        >
          <div className={`flex flex-row justify-start items-center`}>
            {title && <span className={titleStye}>{title}</span>}
            <FileUploader
              setSelectedFile={(file) => {
                // alert('1');
                // if (cropMode) {
                //   setShowCrop(true);
                //   setPreviewImage(file);
                // } else {
                setSelectedFile(file);
                // }
              }}
              id={id}
              accept={accept}
              inputclassname={inputclassname}
              extraLabelStyle={extraLabelStyle}
              type={type}
            >
              {children}{' '}
            </FileUploader>
          </div>
          {affix &&
            affix !== 'undefined' &&
            affix !== undefined &&
            !loadingU && (
              <span className={affixstyle}>
                {affix}
                <img
                  alt="cancel"
                  src="/imgs/profile/cancel.svg"
                  width={20}
                  height={20}
                  containerclassName={`flex flex-row justify-center items-center pr-[2px] mr-auto ${
                    themeColor != 'white' && 'makeWhite'
                  }`}
                  onClick={removeImage}
                  style={{ cursor: 'pointer' }}
                />
              </span>
            )}

          {loadingU && (
            <Loader className={loadingStyle} width={width} height={height} />
          )}
          {showError && <p className={styles.inputError}>{error}</p>}
        </div>
      </form>
      {/* {cropMode && showCrop && (
        <Modal
          icon={true}
          extraContentStyle={`${styles.containerStyle} ${cropContainer}`}
          iconSrc={`/imgs/profile/upload.svg`}
          containerStyle={styles.noBackground}
          extraContentInsideClass={`${styles.modalContainer} `}
          handleShowModal={handleShowModal}
          title='آماده سازی تصویر'
        >
          <CropImage
            previewImage={previewImage}
            setSelectedFile={setSelectedFile}
            className={`${styles.modalContent} `}
            handleShowModal={handleShowModal}
            showToggle={showToggle}
            suitableAspect={suitableAspect}
          />

        </Modal>
      )}  */}
    </>
  );
}
